export default __webpack_public_path__ + "slices/main/assets/public/fonts/camper/camper-regular.25791fdcd63b72b621099e083341f1da.woff";